import React, { useEffect, useState } from 'react'
import { register as register } from '@bigyellow/api/register'
import { handle_api_exception } from '@bigyellow/api/exception'
import { withStore } from '@bigyellow/store'
import { Button } from 'react-bootstrap'
import NewTotp from '@bigyellow/components/SignIn/NewTotp'

const AuthAppVerification = ({ store , user,  onComplete, onCancel }) => {
  const [submitting, setSubmitting] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [isRequestSent, setIsRequestSent] = useState(false);

  useEffect(() => {
    if (!isRequestSent) {
      // setHasScanned(false);
      requestAppAuth();
    }

  }, []);
  const requestAppAuth = () => {
    const http_client = store.get("http_client");
    const notify = store.get("notify");
    setSubmitting(true);

    register(http_client, {
      customerId: user.customerId,
      email: user.email,
      password: user.password,
    }).then((res) => {
      // let qrCode = res.data.data.qr_code;
      setQrCode( res.data.data);
      // let secret = res.data.data.secret;
      // setDebugData(res.data.debug);
      setIsRequestSent(true);
    }).catch((err) => {
      notify(handle_api_exception(err), {type: 'error'});
    }).finally(() => {
      setSubmitting(false);
    });
  }

  // const authenticateUser = (code) => {
  //   setSubmitting(true);
  //   const http_client = store.get("http_client");
  //   const notify = store.get("notify");
  //   token(http_client, { code: code}).then((res) => {
  //     const { data, code } = res.data;
  //     if (code === 200) {
  //       onComplete(data);
  //     } else {
  //       alert('Oooops. There was a problem.');
  //     }
  //   }).catch((err) => {
  //     if (notify) {
  //       notify(handle_api_exception(err), {type: 'error'});
  //     }
  //   }).finally(() => {
  //     setSubmitting(false);
  //   });
  // }
  if(qrCode === null) {
    return '';
  }


  return (
    <React.Fragment>
      <NewTotp inQrCodedDetails={qrCode} email={user.email} isRegistration={true} onComplete={onComplete}/>
      <Button
        variant="link"
        onClick={onCancel}
        disabled={submitting}
      >
        Select a different method
      </Button>
    </React.Fragment>
  );
}

export default withStore(AuthAppVerification);